
import { getLkApi } from '../apidata';

/**
 * 通用权限校验 
 * @param opt 
 */
async function generalValidate(opt: any) {
    let json = await getLkApi('/api/PermissionAction/GeneralValidate', {
        channel_id: opt.channel_id,
        password: opt.password,
        view_type: opt.viewtype,
        sn_token: opt?.sn_token || "",
        dbg_ticket:opt?.dbg_ticket || ""
    });
    return json;
} 

export {
    generalValidate
}
